import { analytics } from './analytics';
import { format } from './format';
import { handleFocus } from './handle-focus';
import { kz } from './kz';
import { misc } from './misc';
import { prices } from './prices';
import { scroll } from './scroll';
import { seo } from './seo';
import { stringHelpers } from './string-helpers';

const globalMixins = [analytics, format, handleFocus, kz, misc, prices, scroll, seo, stringHelpers];

export const GlobalMixinsPlugin = {
  install: function (Vue) {
    for (const mixin of globalMixins) {
      Vue.mixin(mixin);
    }
  }
};
